import styles from "./StatusBar.module.scss";

export interface StatusBarProps {
  status: string;
}

export function StatusBar({ status }: StatusBarProps) {
  return (
    <p id="status" className={styles.root}>
      {status}
    </p>
  );
}
